export const init = () => {
  /* SHOPPING TOOL - HOMEPAGE */

  if (tc_vars.env_template !== 'homepage') return;

  const fwk = CUBE.Analytics;
  const sep = AnalyticsConstants.separatorST;

  const stType = 'merchandising-hp';

  const trackerName = AnalyticsConstants.trackers.homepage.homepage.name;
  if (!CUBE.Analytics.trackers.list[trackerName]) return;

  const eventName = 'hpPushProduct';
  if (!CUBE.Analytics.trackers.list[trackerName].events[eventName]) return;

  // Get the 'hpPushProduct' event
  const event = CUBE.Analytics.trackers.list[trackerName].events[eventName];

  if (event) {
    event.postAction($element => {
      const positionFloor = fwk.utils.homepage.getFloorIndex($element);

      const product = $element.closest('article');
      const productAll = product.closest('.list-products').find('article');

      fwk.shoppingtool.set(
        stType,
        `floor${sep}${positionFloor}${sep}position${sep}${productAll.index(
          product
        ) + 1}`
      );
    });
  }
};



// WEBPACK FOOTER //
// ./src/analytics/shopping-tool/st-homepage.js